import { usePreferredSubmitIntention } from '../../../../../interface_adapters/hooks/usePreferredSubmitIntention';
import { Button } from '@techem/ui-components';
import { SIZE } from 'baseui/input';
import { Col } from 'react-bootstrap';
import React from 'react';
import { KIND } from 'baseui/button';
import { styled } from 'baseui';
import { TechemTheme } from '@techem/techem-theme';

const LinkButton = styled('button', {
  background: 'none',
  border: 'none',
  color: TechemTheme.colors.primary,
  textDecoration: 'underline',
  cursor: 'pointer',
  padding: 0,
  fontSize: '1rem',
  fontFamily: 'inherit'
});

interface ButtonOrderProps {
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
  primaryText: string;
  secondaryText: string;
  isPrimaryDisabled: boolean;
  isSecondaryDisabled: boolean;
  isLoading: boolean;
  resetCheckbox: () => void;
}

// TODO: Hardcoded German text, needs to be loaded from i18n
const SubmitButtonView: React.FC<ButtonOrderProps> = ({
  onPrimaryClick,
  onSecondaryClick,
  primaryText,
  secondaryText,
  isPrimaryDisabled,
  isSecondaryDisabled,
  isLoading,
  resetCheckbox
}) => {
  const { preferredSubmitIntention, togglePreferredSubmitIntention } =
    usePreferredSubmitIntention();

  const handleOnClick = () => {
    resetCheckbox();
    togglePreferredSubmitIntention();
  };

  if (preferredSubmitIntention === 'offer') {
    return (
      <>
        <Col className="text-center mb-2" xs={{ span: 12 }}>
          <Button
            kind={KIND.secondary}
            onClick={onSecondaryClick}
            size={SIZE.large}
            disabled={isSecondaryDisabled}
            isLoading={isLoading}
          >
            {secondaryText}
          </Button>
        </Col>
        <Col className={'d-flex justify-content-center'}>
          <LinkButton disabled={isLoading} onClick={handleOnClick} style={{ fontSize: '0.75rem' }}>
            Direkt beauftragen
          </LinkButton>
        </Col>
      </>
    );
  }

  return (
    <>
      <Col className="text-center mb-2" xs={{ span: 12 }}>
        <Button
          onClick={onPrimaryClick}
          disabled={isPrimaryDisabled}
          size={SIZE.large}
          isLoading={isLoading}
        >
          {primaryText}
        </Button>
      </Col>
      <Col className={'d-flex justify-content-center'}>
        <LinkButton disabled={isLoading} onClick={handleOnClick} style={{ fontSize: '0.75rem' }}>
          Zum Angebot wechseln
        </LinkButton>
      </Col>
    </>
  );
};

export default SubmitButtonView;
